import type { TOC } from '@ember/component/template-only'
import { on } from '@ember/modifier'
import { t, formatDate } from 'ember-intl'
import ThemedModal, {
  CloseButton,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'teacher-ui-client/components/base/themed-modal'
import { UiButton } from 'teacher-ui-client/components/ui-button'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'

interface ExpireSignature {
  Element: HTMLDivElement
  Args: {
    assignmentName: string
    confirmAction: () => void
    rejectAction: () => void
    closeModalAction: () => void
    showModal: boolean
  }
}

export const AssignmentExpireModal: TOC<ExpireSignature> = <template>
  <ThemedModal @show={{@showModal}} @close={{@closeModalAction}}>
    <ModalHeader @themeKey={{ThemeKeys.orange}}>
      <h3>{{t "assignments.expireModal.title"}}</h3>
      <CloseButton @close={{@closeModalAction}} />
    </ModalHeader>
    <ModalBody>
      <p data-test-assignment-name>
        {{t "assignments.expireModal.paragraph1" assignmentName=@assignmentName htmlSafe=true}}
      </p>
    </ModalBody>
    <ModalFooter class="space-x-2 text-right">
      <UiButton data-test-reject @appearance={{ButtonAppearance.muted}} {{on "click" @rejectAction}}>
        {{t "assignments.expireModal.noConfirmation"}}
      </UiButton>
      <UiButton data-test-confirm @appearance={{ButtonAppearance.orange}} {{on "click" @confirmAction}}>
        {{t "assignments.expireModal.yesConfirmation"}}
      </UiButton>
    </ModalFooter>
  </ThemedModal>
</template>

interface CreatedSignature {
  Element: HTMLDivElement
  Args: {
    assignmentDescription: string
    themeKey?: ThemeKeys
    confirmAction: () => void
    rejectAction: () => void
    closeModalAction: () => void
    showModal: boolean
    startAt: Date
    studentCount: number
  }
}

export const AssignmentCreatedModal: TOC<CreatedSignature> = <template>
  <ThemedModal @show={{@showModal}} @close={{@closeModalAction}}>
    <ModalHeader @themeKey={{@themeKey}}>
      <h3>{{t "assignments.createdModal.title"}}</h3>
      <CloseButton @close={{@closeModalAction}} />
    </ModalHeader>
    <ModalBody class="space-y-3" data-test-assignment-description>
      <p>
        {{t
          "assignments.createdModal.paragraph1"
          assignmentDescription=@assignmentDescription
          studentCount=@studentCount
          htmlSafe=true
        }}
      </p>
      <p>
        {{t
          "assignments.createdModal.paragraph2"
          startDate=(formatDate @startAt weekday="short" day="2-digit" month="short" year="2-digit")
          htmlSafe=true
        }}
      </p>
    </ModalBody>
    <ModalFooter class="space-x-2 text-right">
      <UiButton data-test-reject @appearance={{ButtonAppearance.muted}} {{on "click" @rejectAction}}>
        {{t "assignments.createdModal.noConfirmation"}}
      </UiButton>
      <UiButton data-test-confirm @appearance={{ButtonAppearance.regular}} {{on "click" @confirmAction}}>
        {{t "assignments.createdModal.yesConfirmation"}}
      </UiButton>
    </ModalFooter>
  </ThemedModal>
</template>
